import DenormalizedSettlementTransactionEditForm from "./DenormalizedSettlementTransactionEditForm";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import {
  pageDenormalizedSettlementTransactionDto,
  searchDenormalizedSettlementTransactionDto,
} from "../../service/DenormalizedSettlementTransactionRequest";

import {
  CircularProgress,
  Typography,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Paper,
  Box,
} from "@material-ui/core";

import { DenormalizedSettlementTransactionAddButtonControl } from "./style/DenormalizedSettlementTransactionStyle";

export default function DenormalizedSettlementTransactionTable() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([["Loading Data..."]]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState(0);
  const [open, setOpen] = useState(false);

  const [addOpen, setAddOpen] = useState(false);
  const [
    editDenormalizedSettlementTransactionDto,
    setEditDenormalizedSettlementTransactionDto,
  ] = useState({});

  const [refreshFlag, setRefreshFlag] = useState(false);

  const [searchName, setSearchName] = useState("");

  const [searchRefreshFlag, setSearchRefreshFlag] = useState(false);

  const searchDenormalizedSettlementTransaction = () => {
    console.log("======searchDenormalizedSettlementTransaction", searchName);
    setSearchRefreshFlag(true);
  };

  const handleClose = () => {
    console.log("======handle close");
    setOpen(!open);
  };

  const handleEditSubmit = () => {
    console.log("======handle edit submit");
    setOpen(!open);
    debugger;

    setTimeout(() => {
      setRefreshFlag(true);
    }, 1000);
  };

  const changePage = (page, sortOrder) => {
    setIsLoading(true);
    debugger;
    console.log("===page", page);
    page = page + 1;
    initData(page, 10);
  };

  const editDenormalizedSettlementTransactionData = (tableMeta) => {
    debugger;
    const row = tableMeta.rowIndex;
    console.log("row", row);
    setOpen(!open);
    const editDenormalizedSettlementTransactionDto = data[row];
    setEditDenormalizedSettlementTransactionDto(
      editDenormalizedSettlementTransactionDto,
    );
  };
  console.log("count===", count);
  const options = {
    filterType: "dropdown",
    responsive: "vertical",
    serverSide: true,
    count: count,
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    sortOrder: { sortOrder },
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    onTableChange: (action, tableState) => {
      console.log(action, tableState);

      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          changePage(tableState.page, tableState.sortOrder);
          break;
        case "sort":
          this.sort(tableState.page, tableState.sortOrder);
          break;
        default:
          console.log("action not handled.");
      }
    },
  };

  const initData = (index, pageSize) => {
    setIsLoading(true);
    debugger;
    pageDenormalizedSettlementTransactionDto(index, pageSize).then((res) => {
      // const albums = res.albums;
      console.log("====data", res.data);
      if (res && res.data) {
        setData(res.data.records);
        setCount(res.data.total);
      }

      setIsLoading(false);

      setPage(index);
    });
  };

  const searchDenormalizedSettlementTransactionData = (
    index,
    pageSize,
    searchName,
  ) => {
    setIsLoading(true);
    searchDenormalizedSettlementTransactionDto(
      index,
      pageSize,
      searchName,
    ).then((res) => {
      // const albums = res.albums;
      console.log("====data", res.data);
      if (res && res.data) {
        setData(res.data.records);
        setCount(res.data.total);
      }

      setIsLoading(false);

      setPage(index);
    });
  };
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // Update the document title using the browser API

    initData(page, 10);
  }, [refreshFlag]);

  useEffect(() => {
    debugger;
    console.log("===searchDenormalizedSettlementTransactionData=");
    if (searchRefreshFlag) {
      console.log("searchName===", searchName);
    }

    if (!searchName) return;
    searchDenormalizedSettlementTransactionData(page, 10, searchName);

    setSearchRefreshFlag(false);
  }, [searchRefreshFlag]);

  const configurationData = {
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    data: [["Loading Data..."]],
    columns: [
      {
        name: "id",
        label: "id",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            // Here you can render a more complex display.
            // You're given access to tableMeta, which has
            // the rowData (as well as the original object data).
            return value.toString();
          },
        },
      },

      {
        name: "isRefund",
        label: "Is Refund",
        options: {},
      },
      {
        name: "transactionId",
        label: "Transaction Id",
        options: {},
      },
      {
        name: "refundId",
        label: "Refund Id",
        options: {},
      },
      {
        name: "settlementRecordId",
        label: "Settlement Record Id",
        options: {},
      },
      {
        name: "businessSettlementSummaryId",
        label: "Business Settlement Summary Id",
        options: {},
      },
      {
        name: "storeSettlementSummaryId",
        label: "Store Settlement Summary Id",
        options: {},
      },
      {
        name: "storeAcquirerSettlementSummaryId",
        label: "Store Acquirer Settlement Summary Id",
        options: {},
      },
      {
        name: "creationTime",
        label: "Create Time",
        options: {},
      },
      {
        name: "Action",
        options: {
          filter: true,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Box>
                <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={(e) =>
                    editDenormalizedSettlementTransactionData(tableMeta)
                  }
                >
                  Edit
                </Button>
              </Box>
            );
          },
        },
      },
    ],
  };

  return (
    <div>
      <div>
        <TextField
          id="id"
          label="Id"
          value={searchName}
          variant="standard"
          onChange={(e) => setSearchName(e.target.value)}
        />
      </div>

      <DenormalizedSettlementTransactionAddButtonControl>
        <Button
          className="btn right"
          variant="outlined"
          onClick={searchDenormalizedSettlementTransaction}
          color="primary"
        >
          Search
        </Button>
      </DenormalizedSettlementTransactionAddButtonControl>

      <MUIDataTable
        title={
          <Typography variant="h6">
            Denormalized Settlement Transaction list
            {isLoading && (
              <CircularProgress
                size={24}
                style={{ marginLeft: 15, position: "relative", top: 4 }}
              />
            )}
          </Typography>
        }
        data={data}
        columns={configurationData.columns}
        options={options}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "100%",
            height: "50%",
          },
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Edit Denormalized Settlement Transaction</DialogTitle>
        <DialogContent>
          <DenormalizedSettlementTransactionEditForm
            handleEditClose={handleClose}
            handleEditSubmit={handleEditSubmit}
            editDenormalizedSettlementTransactionDto={
              editDenormalizedSettlementTransactionDto
            }
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
